import React from "react";
import PageHeader from "../../components/PageHeader";
import CategoryViewComponent from "../../components/Category/CategoryView";

class CategoryView extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Category Detail"
                            Breadcrumb={[
                                { name: "Categories", navigate: "/categories" },
                                { name: "Category Detail", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <CategoryViewComponent />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CategoryView;
